// Tests.js
import React from "react";
import { Card, Button, Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Tests = () => {
  const navigate = useNavigate();
  
  const handleTestOneClick = () => {
    navigate('/test1');
  };

  return (
    <Container className="mt-4">
      <h1>DeepDives</h1>
      <Row>
        <Col md={4}>
          <Card className="mb-4 shadow-sm">
            <Card.Body>
              <Card.Title>The Overview Dive</Card.Title>
              <Card.Text>
                Engage in a choose-your-own-adventure style evaluation. Test your responses through a series of scenarios.
              </Card.Text>
              <Button variant="primary" onClick={handleTestOneClick}>
                Take First DeepDive
              </Button>
            </Card.Body>
          </Card>
        </Col>
        {/* You can add more cards for other tests here */}
      </Row>
    </Container>
  );
};

export default Tests;
